import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/analys.png'


const _withScopeId = n => (_pushScopeId("data-v-2f0017b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"container\" data-v-2f0017b5><div class=\"content-part\" data-v-2f0017b5><div class=\"text-content\" data-v-2f0017b5><h3 class=\"select\" data-v-2f0017b5>Postmatch</h3><h4 class=\"title\" data-v-2f0017b5>Al-driven Posmatch Analysis</h4><p class=\"h4\" data-v-2f0017b5> Review what you did right and what went wrong, see how chaging strategies can affect your win chances. </p></div><div class=\"img-content\" data-v-2f0017b5><img src=\"" + _imports_0 + "\" class=\"section-img\" data-v-2f0017b5></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}